// @flow
import React from 'react';

import SEO from '../../components/seo';
import { AdditionalQuestions } from '../../components/Shelter/components/AdditionalQuestions';
import { Heading } from '../../components/Shelter/components/Heading';
import { HowItWorks } from '../../components/Shelter/components/HowItWorks';
import { Layout } from '../../components/Layout';
import { ShelterLandingMeta } from '../../metadata';

type Props = {
  location: {
    pathname: string,
    href: string,
    search: string,
  },
};

const {
  title,
  description,
} = ShelterLandingMeta;

const Shelter = ({
  location: {
    pathname,
    href,
    search,
  },
}: Props) => (
  <Layout
    currentPathname={pathname}
    currentUrl={href}
  >
    <SEO
      title={title}
      description={description}
      url={href}
    />
    <Heading
      search={search}
    />
    <HowItWorks />
    <AdditionalQuestions />
  </Layout>
);

export default Shelter;
